<app-multimedia-tile-box>
  @if (isLoadingMode()) {
    <ng-container [ngTemplateOutlet]="spinnerTemplateRef" />
  }

  @if (isPreviewMode()) {
    <div
      role="button"
      (click)="handlePreviewClick()">
      <ng-container [ngTemplateOutlet]="previewTemplateRef" />
    </div>
  }

  @if (isDownloadMode()) {
    <div
      class="group"
      role="button"
      (click)="handleDownloadClick()">
      <ng-container [ngTemplateOutlet]="previewTemplateRef" />

      <div
        class="absolute inset-0 hidden items-center justify-center rounded-sm bg-black/50 text-4xl text-white group-hover:flex">
        <app-icon
          [icon]="Icon.CloudDownloadFill"
          tooltipPosition="bottom"
          pTooltip="Pobierz plik" />
      </div>
    </div>
  }

  @if (isSelectMode()) {
    <ng-container [ngTemplateOutlet]="previewTemplateRef" />

    <div
      [ngClass]="borderCssClass()"
      [class.!border-black]="isSelected()"
      [class.border-transparent]="!isSelected()"
      class="absolute -inset-0.5 rounded-sm border-2"></div>
  }

  @if (isRemoveMode()) {
    <ng-container [ngTemplateOutlet]="previewTemplateRef" />

    <app-multimedia-tile-box-remove-button
      (removeClickEvent)="handleRemoveClickEvent()" />
  }
</app-multimedia-tile-box>

<ng-template #spinnerTemplateRef>
  <div class="absolute inset-0 flex items-center justify-center bg-gray-50">
    <app-spinner />
  </div>
</ng-template>

<ng-template #previewTemplateRef>
  @if (previewTemplateData(); as data) {
    @if (info()) {
      <div
        class="absolute inset-0 flex flex-col items-center overflow-hidden p-3 shadow-inner shadow-neutral-50 select-none">
        @switch (true) {
          @case (isImageType() || isDocumentType() || isArchiveType()) {
            <app-image-thumbnail class="my-auto">
              <img
                [class]="previewFillingCssClass()"
                [alt]="data.alt"
                [fill]="true"
                [ngSrc]="data.previewUrl"
                loading="lazy" />
            </app-image-thumbnail>
          }
          @default {
            <app-image-thumbnail-unsupported class="my-auto" />
          }
        }
        <div class="line-clamp-1 text-xs">
          {{ data.filename }}
        </div>

        <div class="py-1 text-left text-xs text-gray-500">
          {{ data.extension | uppercase }} | {{ data.size | filesize }}
        </div>
      </div>
    } @else {
      <div class="absolute inset-0 flex justify-center">
        @switch (true) {
          @case (isImageType() || isDocumentType() || isArchiveType()) {
            <app-image-thumbnail
              class="my-auto"
              size="full">
              <img
                [class]="previewFillingCssClass()"
                [alt]="data.alt"
                [ngSrc]="data.previewUrl"
                [fill]="true"
                loading="lazy" />
            </app-image-thumbnail>
          }
          @default {
            <app-image-thumbnail-unsupported
              class="my-auto"
              size="full" />
          }
        }
      </div>
    }
  } @else {
    <div>Brak wymaganych danych do utworzenia podglądu.</div>
  }
</ng-template>
